/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface QuoteTestGroup
 */
export interface QuoteTestGroup {
  /**
   *
   * @type {string}
   * @memberof QuoteTestGroup
   */
  groupId?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof QuoteTestGroup
   */
  createdAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof QuoteTestGroup
   */
  createdBy?: string;
  /**
   *
   * @type {string}
   * @memberof QuoteTestGroup
   */
  carrierIdentifier?: string;
  /**
   *
   * @type {string}
   * @memberof QuoteTestGroup
   */
  serviceIdentifier?: string;
  /**
   *
   * @type {string}
   * @memberof QuoteTestGroup
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof QuoteTestGroup
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof QuoteTestGroup
   */
  metadata?: string;
}

/**
 * Check if a given object implements the QuoteTestGroup interface.
 */
export function instanceOfQuoteTestGroup(
  value: object,
): value is QuoteTestGroup {
  return true;
}

export function QuoteTestGroupFromJSON(json: any): QuoteTestGroup {
  return QuoteTestGroupFromJSONTyped(json, false);
}

export function QuoteTestGroupFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): QuoteTestGroup {
  if (json == null) {
    return json;
  }
  return {
    groupId: json["groupId"] == null ? undefined : json["groupId"],
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
    createdBy: json["createdBy"] == null ? undefined : json["createdBy"],
    carrierIdentifier:
      json["carrierIdentifier"] == null ? undefined : json["carrierIdentifier"],
    serviceIdentifier:
      json["serviceIdentifier"] == null ? undefined : json["serviceIdentifier"],
    title: json["title"] == null ? undefined : json["title"],
    description: json["description"] == null ? undefined : json["description"],
    metadata: json["metadata"] == null ? undefined : json["metadata"],
  };
}

export function QuoteTestGroupToJSON(json: any): QuoteTestGroup {
  return QuoteTestGroupToJSONTyped(json, false);
}

export function QuoteTestGroupToJSONTyped(
  value?: QuoteTestGroup | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    groupId: value["groupId"],
    createdAt: value["createdAt"],
    createdBy: value["createdBy"],
    carrierIdentifier: value["carrierIdentifier"],
    serviceIdentifier: value["serviceIdentifier"],
    title: value["title"],
    description: value["description"],
    metadata: value["metadata"],
  };
}
